// Adapter para la API de pedidos enviados por cliente hijo
// Child Team Orders API adapter

import { apiClientWH } from '@shared/services/ApiClient';

// 🎯 Interfaces para la respuesta de la API
export interface ChildTeamData {
    team_id: number;
    team_name: string;
    orders_sent_today: number;
}

export interface ChildTeamOrdersData {
    parent_team_id: number;
    date: string;
    child_teams: ChildTeamData[];
}

export interface ChildTeamOrdersResponse {
    success: boolean;
    data: ChildTeamOrdersData;
    message?: string;
}

export class ChildTeamOrdersApiAdapter {
    constructor(private httpClient: typeof apiClientWH) { }

    /**
     * GET /report/orders-sent-by-child-team
     * Obtiene el conteo de pedidos enviados HOY agrupados por cada cliente hijo (tenant_external)
     * 
     * ⚠️ Solo disponible para usuarios con team type = tenant_3pl
     * 
     * @returns Promise<ChildTeamOrdersResponse>
     */
    async getOrdersSentByChildTeam(): Promise<ChildTeamOrdersResponse> {
        const response = await this.httpClient.get('/report/orders-sent-by-child-team');
        return response.data;
    }
}

